<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="runOCR()" [modalHasVariableHeight]="true"
    [isPrimaryBtnEnabled]="isRunOCREnabled()" [secondaryButtonLabel]="secondaryButtonLabel"
    [modalHelpIndex]="modalHelpIndex" (closeButtonActionEmt)="closeModal()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage">
    <div class="modal-row">
        <div class="modal-row-column-auto column-left-text">
            <label>Language Selection: </label>
        </div>
        <div class="modal-row-column-auto">
            <select name="selectedLanguage" automationId="ocr-settings-language-selection-dropdown"
                [(ngModel)]="selectedLanguage" class="select-language-input">
                <option *ngFor="let language of languages | values" [value]="language">{{language}}</option>
            </select>
        </div>
    </div>
    <div class="modal-row">
        <div class="modal-row-column-auto column-left-text accuracy-title">
            <label>Accuracy:</label>
        </div>
        <div class="modal-row-column-auto accuracy-radio-spacer">
            <div class="section">
                <res-custom-radio-button [automationId]="'ocr-settings-medium'" [(ngModel)]="ocrAccuracyHigh"
                    content="Medium" name="accuracyLevel" [value]="false"></res-custom-radio-button>
                <res-custom-radio-button [automationId]="'ocr-settings-high'" [(ngModel)]="ocrAccuracyHigh"
                    content="High" name="accuracyLevel" [value]="true"></res-custom-radio-button>
            </div>
        </div>
    </div>
    <div class="modal-row page-time-out-row">
        <div class="modal-row-column-auto column-left-text page-timeout">
            <label>Page Timeout: </label>
        </div>
        <div class="modal-row-column-auto">
            <input type="number" min="1" step="1"
                onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                (input)="updateAutoOCRPageTimeout($event)" name="ocrPageTimeout" class="page-timeout-width"
                [(ngModel)]="ocrPageTimeout" [value]="ocrPageTimeout"
                data-automation-id="'ocr-settings-page-timeout-input'" [(resScrollablePopover)]="showErrorPopup"
                popoverErrorMessage="Only non-zero values !" popoverType="error" popoverPlacement="bottom"
                [popoverAutomationId]="modalAutomationId + '-page-timeout-error-label'" [isSingleLine]="true">
        </div>
        <div class="modal-row-column-auto">
            <label>seconds</label>
        </div>
    </div>
</res-base-modal>